// The DELETE answers 204 with no body: there is nothing to carry beyond the ownership context, so
// `payload` is omitted entirely rather than filled with a placeholder key nobody reads.
export type IdentityProviderDeletedAction = {
	type: 'IDENTITY_PROVIDER_DELETED';
	accountId: number;
};

export default (accountId: number): IdentityProviderDeletedAction => ({
	type: 'IDENTITY_PROVIDER_DELETED',
	accountId,
});
